import { MappedClass, MappedProperty, MappedPropertyArrayOptional, MappedPropertyCurrency } from '@h5s/util-object';
import Big from 'big.js';
import { ResourceReferenceType } from './resource-reference-type';
import { PriceList } from '../../reservation/entities';

export interface ResourceReferenceFields {
  id: number;
  type: ResourceReferenceType;
  ownerId: number;
  description: string;
  available: boolean;
  basePrice: Big;
  vat: Big | null;
  vatRateId: number | null;
  departmentId: number | null;
  costCenterId: number | null;
  defaultPriceListId: number | null;
  exportCode: string | null;
  /**
   * Nello schema `ResourceReferenceDTO.priceLists` è un array non nullable: se una query lo
   * seleziona, arriva sempre come array (eventualmente vuoto), mai `null`/assente.
   *
   * Qui è opzionale perché questa entità è popolata da due query con selection set diversi:
   * - `resource.fragment.graphql` (fragment `ResourceReference`, usato da `SearchResourcePaginated`
   *   → `feature-resource-list`) seleziona `priceLists { ...PriceList }` ed è quindi sempre presente.
   * - `get-price-list-included-resources.query.graphql` seleziona i campi di `resource` a mano
   *   (non usa il fragment) e omette `priceLists` di proposito: il fragment `PriceList` è pesante
   *   (~70 campi) e questa vista (elenco "servizi inclusi" in un listino) non usa mai quel dato.
   *
   * Quindi qui il campo è realmente assente dalla risposta, non `null` — da qui `allowUndefined`.
   */
  priceLists?: PriceList[];
}

@MappedClass()
export class ResourceReference implements ResourceReferenceFields {
  @MappedProperty()
  id: number;

  @MappedProperty()
  type: ResourceReferenceType;

  @MappedProperty()
  ownerId: number;

  @MappedProperty()
  description: string;

  @MappedProperty()
  available: boolean;

  @MappedPropertyCurrency()
  basePrice: Big;

  @MappedPropertyCurrency()
  vat: Big | null;

  @MappedProperty()
  vatRateId: number | null;

  @MappedProperty()
  departmentId: number | null;

  @MappedProperty()
  costCenterId: number | null;

  @MappedProperty()
  defaultPriceListId: number | null;

  @MappedProperty()
  exportCode: string | null;

  @MappedPropertyArrayOptional(() => PriceList)
  priceLists?: PriceList[];

  constructor(fields?: ResourceReferenceFields) {
    if (!fields) return;

    Object.assign(this, fields);
  }
}
